module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


//////////////////
// WEBPACK FOOTER
// external {"root":"WaveSurfer","commonjs2":"wavesurfer.js","commonjs":"wavesurfer.js","amd":"wavesurfer"}
// module id = 2
// module chunks = 0 1